import { Chip } from './Chip';

/**
 * Marks a row that came from "Load sample data" so a demo record can never be
 * mistaken for a real one. Renders nothing when the row is real.
 */
export function SampleBadge({ when }: { when?: boolean }) {
  if (!when) return null;
  return (
    <span title="Example record. Remove it any time from Settings." style={{ marginLeft: 7 }}>
      <Chip tone="example" size="sm" caps outline>
        Example
      </Chip>
    </span>
  );
}
